import {Duration, Ticker} from '../../../../kit/src';
import * as moment from 'moment';
import * as React from 'react';

import {Revision, Timestamp} from '../../../shared/components';
import * as models from '../../../shared/models';

import {getHydratorSyncSourceRepoURL} from '../utils';

import './application-hydrate-operation-state.scss';

interface Props {
    hydrateOperationState: models.HydrateOperation;
}

export const ApplicationHydrateOperationState: React.FunctionComponent<Props> = ({hydrateOperationState}) => {
    const operationAttributes = [
        {title: 'Phase', value: hydrateOperationState.phase},
        ...(hydrateOperationState.message ? [{title: 'Message', value: hydrateOperationState.message}] : []),
        {title: 'Started at', value: <Timestamp date={hydrateOperationState.startedAt} />},
        {
            title: 'Duration',
            value: (
                <Ticker>
                    {time => (
                        <Duration
                            durationS={
                                ((hydrateOperationState.finishedAt && moment(hydrateOperationState.finishedAt)) || moment(time)).diff(moment(hydrateOperationState.startedAt)) /
                                1000
                            }
                        />
                    )}
                </Ticker>
            )
        }
    ];

    if (hydrateOperationState.finishedAt && hydrateOperationState.phase !== 'Hydrating') {
        operationAttributes.push({title: 'Finished at', value: <Timestamp date={hydrateOperationState.finishedAt} />});
    }
    if (hydrateOperationState.drySHA) {
        operationAttributes.push({
            title: 'Dry revision',
            value: (
                <div>
                    <Revision repoUrl={hydrateOperationState.sourceHydrator.drySource.repoURL} revision={hydrateOperationState.drySHA} />
                </div>
            )
        });
    }
    if (hydrateOperationState.finishedAt && hydrateOperationState.hydratedSHA) {
        operationAttributes.push({
            title: 'Hydrated revision',
            value: (
                <div>
                    <Revision repoUrl={getHydratorSyncSourceRepoURL(hydrateOperationState.sourceHydrator)} revision={hydrateOperationState.hydratedSHA} />
                </div>
            )
        });
    }
    return (
        <div>
            <div className='white-box'>
                <div className='white-box__details'>
                    {operationAttributes.map(attr => (
                        <div className='row white-box__details-row' key={attr.title}>
                            <div className='columns small-3'>{attr.title}</div>
                            <div className='columns small-9'>{attr.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
